import SITE_CONFIG from '../config/siteConfig'

const base = SITE_CONFIG.domain.replace(/\/$/, '')

const page = (path, title, description) => ({
  path,
  title,
  description,
  canonical: `${base}${path}`,
})

export const SEO_ROUTES = [
  page('/', 'KoolMind | Responsible Technology Partner', 'KoolMind builds mobile apps, web apps, and AI solutions with reliable delivery and support.'),
  page('/services', 'Services | KoolMind', 'Full-stack services: mobile, web, UI/UX, AI/ML, MCP, and backend development.'),
  page('/services/mobile-app-development', 'Mobile App Development | KoolMind', 'Native and cross-platform mobile app development focused on performance and scalability.'),
  page('/services/web-app-development', 'Web App Development | KoolMind', 'Custom web applications with secure backend, integrations, and responsive UX.'),
  page('/services/ui-ux-designing', 'UI/UX Design | KoolMind', 'Product UI/UX design: research, wireframes, prototypes, and production-ready design systems.'),
  page('/services/ai-machine-learning-development', 'AI/ML Development | KoolMind', 'AI/ML solutions, data pipelines, and intelligent features for modern products.'),
  page('/services/mcp-development', 'MCP Development | KoolMind', 'Model Context Protocol (MCP) integrations and multi-model orchestration services.'),

  page('/industries', 'Industries | KoolMind', 'Solutions for healthcare, education, ecommerce, social, fitness, and more.'),
  page('/industries/healthcare', 'Healthcare Solutions | KoolMind', 'Health tech apps, telemedicine, and secure patient experiences.'),
  page('/industries/education', 'Education Solutions | KoolMind', 'EdTech platforms for learning, assessment, and engagement.'),
  page('/industries/petcare', 'PetCare Solutions | KoolMind', 'Pet care apps for booking, health tracking, and engagement.'),
  page('/industries/homecare', 'Homecare Solutions | KoolMind', 'Homecare service platforms with scheduling and provider management.'),
  page('/industries/social-media', 'Social Media Apps | KoolMind', 'Social apps built for scale, engagement, and creator tools.'),
  page('/industries/dating', 'Dating Apps | KoolMind', 'Secure dating platforms with matching, messaging, and analytics.'),
  page('/industries/fitness', 'Fitness Apps | KoolMind', 'Fitness and wellness apps with tracking and community features.'),
  page('/industries/textile-garments', 'Textile & Garments Solutions | KoolMind', 'Digital solutions for textile and garment operations and commerce.'),

  page('/about', 'About Us | KoolMind', 'Know KoolMind—team, mission, and responsible technology values.'),
  page('/our-story', 'Our Story | KoolMind', 'KoolMind story and how we partner with businesses.'),
  page('/our-journey', 'Our Journey | KoolMind', 'Milestones and journey of KoolMind.'),
  page('/life-at-koolmind', 'Life at KoolMind | KoolMind', 'Culture, growth, and life at KoolMind.'),

  page('/our-works', 'Our Works | KoolMind', 'Showcase of delivered solutions and success stories.'),
  page('/case-studies', 'Case Studies | KoolMind', 'Case studies across industries demonstrating outcomes.'),
  page('/our-clients', 'Our Clients | KoolMind', 'Brands and clients that trust KoolMind.'),
  page('/pricing', 'Pricing | KoolMind', 'Transparent pricing options and care plans.'),
  page('/contact', 'Contact Us | KoolMind', 'Talk to KoolMind about your next product or project.'),
  page('/career', 'Career | KoolMind', 'Join KoolMind—open roles and opportunities.'),

  page('/blogs', 'Blogs | KoolMind', 'Insights, updates, and learnings from KoolMind.'),
]

export const resolveSeo = (pathname) => {
  const exact = SEO_ROUTES.find((r) => r.path === pathname)
  if (exact) return exact

  // Dynamic routes: blogs/:id, case-studies/:slug, work-details/:slug
  if (pathname.startsWith('/blogs/')) {
    return page(pathname, 'Blog Details | KoolMind', 'Read the latest insights from KoolMind.')
  }
  if (pathname.startsWith('/case-studies/')) {
    return page(pathname, 'Case Study | KoolMind', 'Detailed case study from KoolMind.')
  }
  if (pathname.startsWith('/work-details/')) {
    return page(pathname, 'Work Details | KoolMind', 'Project details delivered by KoolMind.')
  }

  // Fallback
  return page(pathname, SITE_CONFIG.defaultTitle, SITE_CONFIG.description)
}

export default resolveSeo

